import React, { useEffect, useState } from "react";
import TransmitterFaceplate from "./TransmitterFaceplate";

function PinnedTransmittersLayer() {
  const [pinnedList, setPinnedList] = useState([]);

  // ================= LOAD PINNED =================
  useEffect(() => {
    const loadPinned = () => {
      const keys = Object.keys(localStorage);

      const pins = keys
        .filter((k) => k.startsWith("pin_") && localStorage.getItem(k) === "true")
        .map((k) => k.replace("pin_", ""));

      setPinnedList(pins);
    };

    loadPinned();

    // 🔄 Listen for changes (important for multi-page sync)
    window.addEventListener("storage", loadPinned);

    return () => window.removeEventListener("storage", loadPinned);
  }, []);

  // ================= REMOVE PIN =================
  const handleUnpin = (tag) => {
    localStorage.setItem(`pin_${tag}`, "false");
    setPinnedList(prev => prev.filter(t => t !== tag));
  };

  return (
    <>
      {pinnedList.map((tag) => {

        const value = Number(localStorage.getItem(`transmitter_${tag}`)) || 0;

        const pos = JSON.parse(localStorage.getItem(`pos_${tag}`) || "{}");

        return (
          <TransmitterFaceplate
            key={tag}
            tag={tag}
            value={value}
            unit={localStorage.getItem(`unit_${tag}`) || ""}
            min={Number(localStorage.getItem(`min_${tag}`)) || 0}
            max={Number(localStorage.getItem(`max_${tag}`)) || 100}
            HH={Number(localStorage.getItem(`HH_${tag}`)) || 90}
            H={Number(localStorage.getItem(`H_${tag}`)) || 75}
            L={Number(localStorage.getItem(`L_${tag}`)) || 25}
            LL={Number(localStorage.getItem(`LL_${tag}`)) || 10}
            description={localStorage.getItem(`description_${tag}`) || ""}

            x={pos.x || 200}
            y={pos.y || 120}

            onClose={() => handleUnpin(tag)}
          />
        );
      })}
    </>
  );
}

export default PinnedTransmittersLayer;